import"../dayjs.js";import dayjs from"../../node_modules/dayjs/dayjs.min.js";const defaultOptions={removeInSuffix:!1},toNow=(dt,options=defaultOptions)=>(typeof dt=="string"?dayjs(dt):dt).toNow(options.removeInSuffix);export{toNow};
